/**
 * Admin Center Client Mod — 注册器
 *
 * 通过 DI 获取 UI Registry 服务，注册管理员中心页面路由。
 */
import { ADMIN_PATH } from '@hvsin/admin-contracts';
import { AdminPage } from './pages/admin-page.js';
/**
 * 管理员中心注册器
 *
 * 将管理员中心页面注册到路由系统中，并注入 slots service。
 */
export class AdminRegistrar {
    constructor(deps) {
        const { pageRouteRegistry, adminSlots } = deps;
        pageRouteRegistry.registerPage({
            path: ADMIN_PATH,
            component: () => AdminPage({ slotsService: adminSlots }),
            key: 'admin-center',
            meta: {
                title: '管理员中心',
                requiresAuth: true,
                requiresAdmin: true,
            },
            modName: 'admin-center-client',
        });
    }
}
//# sourceMappingURL=admin-registrar.js.map